<script>
  import { TopBar, LoadingOverlay } from '@/components/_shared'
  import { appStoreResource } from '@/api'

  export default {
    name: 'app-store-show-view',

    components: {
      TopBar,
      LoadingOverlay
    },

    metaInfo: {
      title: 'App Details'
    },

    data () {
      return {
        loading: true,
        app: {}
      }
    },

    created () {
      const id = this.$route.params.id

      appStoreResource.find(id).then(res => {
        this.app = res
        this.loading = false
      })
    }
  }
</script>

<template>
  <div class="app-store">
    <top-bar :title="app.name" icon="store" back-to="/store"/>
    <loading-overlay :is-loading="loading"></loading-overlay>
  </div>
</template>

<style src="./AppStoreShowView.scss" lang="scss" scoped></style>
